/* Shop & Go storefront */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { routes: {} };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function money(cents) {
    const fmt = T.moneyFormat || 'R {{amount}}';
    const n = (Number(cents) / 100);
    const amount = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, amount);
  }
  const imgSize = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  /* Header height for sticky offsets */
  const hd = $('[data-header]');
  const setH = () => hd && document.documentElement.style.setProperty('--hd-h', hd.offsetHeight + 'px');
  setH(); addEventListener('resize', setH);

  /* Mega menu */
  const megaBtn = $('[data-mega-toggle]'), mega = $('[data-mega]');
  if (megaBtn && mega) {
    const set = open => { mega.hidden = !open; megaBtn.setAttribute('aria-expanded', open); };
    megaBtn.addEventListener('click', () => set(mega.hidden));
    document.addEventListener('click', e => { if (!mega.hidden && !e.target.closest('[data-mega]') && !e.target.closest('[data-mega-toggle]')) set(false); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') set(false); });
  }

  /* Mobile nav drawer */
  const drawer = $('[data-drawer]'), openBtn = $('[data-drawer-open]');
  if (drawer && openBtn) {
    const open = () => { drawer.setAttribute('open', ''); openBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.removeAttribute('open'); openBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };
    openBtn.addEventListener('click', open);
    $$('[data-drawer-close]', drawer).forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.hasAttribute('open')) close(); });
  }

  /* Predictive search */
  $$('[data-predictive]').forEach(form => {
    const input = $('input[type=search]', form), box = $('.ps', form);
    if (!input || !box || !window.fetch) return;
    let t, ctrl, items = [], idx = -1;
    const hide = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); idx = -1; };
    const render = (q, products) => {
      if (!products.length) { box.innerHTML = `<p class="ps__none">No products match "${esc(q)}". Try a shorter word.</p>`; }
      else {
        box.innerHTML = products.map((p, i) => `<a class="ps__item" role="option" id="ps-${i}" href="${esc(p.url)}">${p.image ? `<img class="ps__img" src="${esc(imgSize(p.image, 120))}" alt="" loading="lazy">` : '<span class="ps__img"></span>'}<span class="ps__t">${esc(p.title)}</span><span class="ps__p">${esc(money(Math.round(parseFloat(p.price) * 100)))}</span></a>`).join('')
          + `<a class="ps__all" href="${T.routes.search}?q=${encodeURIComponent(q)}&type=product">See all results for "${esc(q)}"</a>`;
      }
      items = $$('.ps__item', box); idx = -1;
      box.hidden = false; input.setAttribute('aria-expanded', 'true');
    };
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) return hide();
      t = setTimeout(async () => {
        try {
          ctrl && ctrl.abort(); ctrl = new AbortController();
          const r = await fetch(`${T.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, { signal: ctrl.signal });
          const j = await r.json();
          render(q, (j.resources && j.resources.results && j.resources.results.products) || []);
        } catch (e) { /* ignore aborted */ }
      }, 180);
    });
    input.addEventListener('keydown', e => {
      if (box.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = (idx + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach((a, i) => a.setAttribute('aria-selected', i === idx));
        input.setAttribute('aria-activedescendant', items[idx].id);
      } else if (e.key === 'Enter' && idx > -1) { e.preventDefault(); location.href = items[idx].href; }
      else if (e.key === 'Escape') hide();
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) hide(); });
  });

  /* Quantity steppers */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = $('input', b.closest('.qty'));
    const min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart drawer */
  const cd = $('[data-cart-drawer]');
  const setCount = n => $$('[data-cart-count]').forEach(el => { el.textContent = n; el.dataset.count = n; });
  async function getCart() { return (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json(); }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cd) return;
    $('[data-cd-count]', cd).textContent = cart.item_count ? `(${cart.item_count})` : '';
    $('[data-cd-total]', cd).textContent = money(cart.total_price);
    $('[data-cd-checkout]', cd).toggleAttribute('hidden', !cart.item_count);
    $('[data-cd-lines]', cd).innerHTML = cart.items.length ? cart.items.map((it, i) => `
      <div class="cd__line">
        <img class="cd__img" src="${esc(imgSize(it.image, 160))}" alt="" loading="lazy">
        <div>
          <a class="cd__t" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.product_has_only_default_variant ? '' : `<p class="cd__v">${esc(it.variant_title)}</p>`}
          <div class="qty"><button type="button" data-qty="-1" aria-label="Decrease">&minus;</button><input type="number" min="0" value="${it.quantity}" data-line="${i + 1}" aria-label="Quantity"><button type="button" data-qty="1" aria-label="Increase">+</button></div>
        </div>
        <div><div class="cd__p">${money(it.final_line_price)}</div><button class="cd__rm" type="button" data-remove="${i + 1}">Remove</button></div>
      </div>`).join('') : `<p class="cd__empty">Your cart is empty.</p>`;
  }
  function openCart(msg) {
    if (!cd) { location.href = T.routes.cart; return; }
    const added = $('[data-cd-added]', cd);
    if (msg) { added.textContent = msg; added.hidden = false; } else added.hidden = true;
    cd.hidden = false; document.body.style.overflow = 'hidden';
    const c = $('[data-cart-close]', $('.cd__panel', cd)); c && c.focus();
  }
  function closeCart() { if (cd) { cd.hidden = true; document.body.style.overflow = ''; } }
  if (cd) {
    $$('[data-cart-close]', cd).forEach(b => b.addEventListener('click', closeCart));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !cd.hidden) closeCart(); });
    $$('[data-cart-open]').forEach(a => a.addEventListener('click', async e => {
      if (document.body.classList.contains('tpl-cart')) return;
      e.preventDefault(); renderCart(await getCart()); openCart();
    }));
    let ct;
    const change = async (line, quantity) => {
      const r = await fetch(T.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      renderCart(await r.json());
    };
    cd.addEventListener('change', e => { const i = e.target.closest('[data-line]'); if (!i) return; clearTimeout(ct); ct = setTimeout(() => change(+i.dataset.line, Math.max(0, +i.value || 0)), 300); });
    cd.addEventListener('click', e => { const r = e.target.closest('[data-remove]'); if (r) change(+r.dataset.remove, 0); });
  }
  async function addToCart(formData) {
    const res = await fetch(T.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Could not add this item.');
    renderCart(await getCart());
    openCart(`Added: ${json.product_title}`);
    return json;
  }

  /* Quick add on product cards */
  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-quick-add]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    const btn = $('button', f), label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    try { await addToCart(new FormData(f)); f.classList.add('is-added'); btn.textContent = 'Added'; setTimeout(() => { f.classList.remove('is-added'); btn.textContent = label; }, 1800); }
    catch (ex) { btn.textContent = label; alert(ex.message); }
    finally { btn.disabled = false; }
  });

  /* Delivery estimate (business days, weekends skipped) */
  const eta = $('[data-eta]');
  if (eta && T.delivery) {
    const addBiz = (d, n) => { const x = new Date(d); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w !== 0 && w !== 6) k++; } return x; };
    const f = d => d.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' });
    const now = new Date();
    eta.textContent = `between ${f(addBiz(now, T.delivery.min))} and ${f(addBiz(now, T.delivery.max))}`;
  }

  /* Product page */
  const pp = $('[data-product]');
  if (pp) {
    const data = JSON.parse(($('[data-product-json]') || {}).textContent || '{"variants":[]}');
    const radios = $$('input[data-option-index]', pp);
    const idInput = $('[data-variant-id]', pp), addBtn = $('[data-add]', pp), stock = $('[data-stock]', pp);
    const sku = $('[data-sku]', pp), now = $('[data-price-current]', pp), was = $('[data-price-compare]', pp), save = $('[data-price-save]', pp);
    const slides = $('[data-slides]', pp), thumbs = $$('[data-thumb]', pp);
    const stickyPrice = $('[data-sticky-price]'), stickyBtn = $('[data-sticky-add]');
    const goSlide = i => { if (!slides) return; slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' }); thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i)); };
    thumbs.forEach(t => t.addEventListener('click', () => goSlide(+t.dataset.thumb)));
    if (slides) slides.addEventListener('scroll', () => { const i = Math.round(slides.scrollLeft / slides.clientWidth); thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i)); }, { passive: true });
    const selected = () => { const n = Math.max(0, ...radios.map(r => +r.dataset.optionIndex)) + 1; const out = []; for (let i = 0; i < n; i++) { const r = radios.find(x => +x.dataset.optionIndex === i && x.checked); out.push(r ? r.value : null); } return out; };
    const update = () => {
      const chosen = selected();
      chosen.forEach((v, i) => { const l = $(`[data-opt-label="${i}"]`, pp); if (l) l.textContent = v; });
      radios.forEach(r => { const test = chosen.slice(); test[+r.dataset.optionIndex] = r.value; const m = data.variants.find(x => x.options.every((o, i) => o === test[i])); r.closest('.pill').classList.toggle('is-na', !m || !m.available); });
      const v = data.variants.find(x => x.options.every((o, i) => o === chosen[i]));
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; stock.textContent = 'This combination is not available'; stock.classList.add('stock--out'); if (stickyBtn) stickyBtn.disabled = true; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      stock.textContent = v.stock; stock.classList.toggle('stock--out', !v.available);
      if (sku) sku.textContent = v.sku || 'n/a';
      now.textContent = v.price; if (stickyPrice) stickyPrice.textContent = v.price;
      was.hidden = !v.compare; was.textContent = v.compare || '';
      save.hidden = !v.save; save.textContent = v.save ? 'You save ' + v.save : '';
      if (v.media && slides) { const idx = $$('.pp__slide', slides).findIndex(s => s.dataset.mediaId == v.media); if (idx > -1) goSlide(idx); }
      history.replaceState(null, '', v.url);
    };
    radios.forEach(r => r.addEventListener('change', update));
    if (radios.length) update();
    const form = $('[data-product-form]', pp), err = $('[data-form-error]', pp);
    if (form && window.fetch) form.addEventListener('submit', async e => {
      e.preventDefault(); err.hidden = true; addBtn.disabled = true; const label = addBtn.textContent; addBtn.textContent = 'Adding…';
      try { await addToCart(new FormData(form)); } catch (ex) { err.textContent = ex.message; err.hidden = false; }
      finally { addBtn.disabled = false; addBtn.textContent = label; }
    });
    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      stickyBtn && stickyBtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : addBtn.click());
    }
  }

  /* Scrolling product rows */
  $$('[data-row]').forEach(row => {
    const sec = row.closest('section'); if (!sec) return;
    const step = () => row.clientWidth * .8;
    const p = $('[data-row-prev]', sec), n = $('[data-row-next]', sec);
    p && p.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
    n && n.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* Recommendations */
  const recs = $('[data-recs]');
  if (recs && !recs.children.length && window.fetch) {
    fetch(recs.dataset.url).then(r => r.text()).then(html => {
      const inner = $('[data-recs]', new DOMParser().parseFromString(html, 'text/html'));
      if (inner && inner.innerHTML.trim()) recs.innerHTML = inner.innerHTML; else recs.remove();
    }).catch(() => recs.remove());
  }

  /* Filters and sort */
  const filterForm = $('[data-filter-form]');
  if (filterForm) { let t; filterForm.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit(), 350); }); }
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });
  const ft = $('[data-filters-toggle]');
  if (ft && filterForm) ft.addEventListener('click', () => { const o = filterForm.classList.toggle('is-open'); ft.setAttribute('aria-expanded', o); });

  /* Cart page: optional policy checkbox */
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    const terms = $('[data-terms]', cartForm);
    cartForm.addEventListener('submit', e => {
      const sub = e.submitter;
      if (terms && sub && sub.name === 'checkout' && !terms.checked) { e.preventDefault(); terms.focus(); terms.closest('.terms').style.color = 'var(--sale)'; }
    });
  }
})();
